export default __webpack_public_path__ + "static/media/andrea.f8452c7e.png";